import { toStyleNameKey } from './styleNameKey';

/**
 * Builds extracted-name / nameKey / id lookups from beerStyles catalog rows.
 */
export function buildCatalogStyleMapping(beerStyles = []) {
  const mapping = {};
  beerStyles.forEach((style) => {
    if (!style?.id) {
      return;
    }
    mapping[style.id] = style.id;
    if (typeof style.name === 'string' && style.name.trim()) {
      mapping[style.name.trim()] = style.id;
      mapping[toStyleNameKey(style.name)] = style.id;
    }
    if (typeof style.nameKey === 'string' && style.nameKey.trim()) {
      mapping[style.nameKey.trim()] = style.id;
    }
  });
  return mapping;
}
